import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngstack/translate';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SubsidiaryStudentService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-student.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-subsidiary-dashboard-import-student-files',
  templateUrl: './subsidiary-dashboard-import-student-files.component.html',
  styleUrls: ['./subsidiary-dashboard-import-student-files.component.css']
})
export class SubsidiaryDashboardImportStudentFilesComponent implements OnInit {

  form: FormGroup;
  isSuccessFileUpload: any;
  fileList=[];
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    public subsidiaryStudentService: SubsidiaryStudentService,
    private dialogRef: MatDialogRef<SubsidiaryDashboardImportStudentFilesComponent>,

    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      ContractId: [this.data.ContractId],
      Password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(30)
        ])
      ],
      NationalCodeListFile: [
        null,
        Validators.compose([
          Validators.required
        ])
      ],
      Extension: [
        null,
        Validators.compose([
          Validators.required
        ])
      ]

    });
  }

  onFileChange(event) {

    let files=[];
    this.fileList=[];
    for(const element of event.target.files) {
     files.push(element);
   }
       if (files) {
         const extension=files[0].name.split('.').pop();
        this.form.controls["Extension"].setValue(extension);
         files.forEach((item,key)=> {
             this.fileList.push({FileDisplayName:item.name});
         if (item.size <= 99999999) {
           const reader = new FileReader();
           reader.onload = this._handleReaderLoaded.bind(this,key);
           reader.readAsBinaryString(item);
           this.isSuccessFileUpload=true;

         } else {
           this.isSuccessFileUpload=false;

           this.snackBar.OpenSnackBar(

             this.translate.get("require.fileUpload", {
               size: "100kb"
             }),
             "ok",
             5000,
             SoundEnum.beep
           );
         }
   });
 }

   }

   _handleReaderLoaded(key,readerEvt) {

     this.fileList[key].ImageData=btoa(readerEvt.target.result);
     let image= this.fileList[this.fileList.length - 1];
     this.form.controls["NationalCodeListFile"].setValue(image.ImageData);
   }
  submit(form :any){

      this.subsidiaryStudentService.contractFileXLS(form).subscribe(() => {

        this.snackBar.OpenSnackBar(
         "لیست دانشجویان با موفقیت اضافه شد",
          "ok",
          3000,
          SoundEnum.beep
        );
        this.onNoClick();
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error)
      });
  }

  onNoClick() {
    this.dialogRef.close();
  }
}

